/* eslint-disable */
export enum Origins {
    LOCAL = 'https://localhost:5001',
    DEV = 'https://dev.danbolig.dk',
    TST = 'https://tst.danbolig.dk',
    UAT = 'https://uat.danbolig.dk',
    PRD = 'https://danbolig.dk',
}
